import React from 'react';
import { MessageCircle, Webhook, Plus, Trash2 } from 'lucide-react';
import { SettingsIcon } from './SettingsIcon';

export const DiscordWebhookList = ({ webhooks, onEdit, onDelete, onAdd }) => {
    return (
        <div className="space-y-4">
            <div className="flex justify-between items-center">
                <h2 className="text-lg font-bold text-gray-900">Configured Webhooks</h2>
                <button
                    type="button"
                    onClick={onAdd}
                    className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
                >
                    <Plus className="w-4 h-4" />
                    Add Webhook
                </button>
            </div>

            {webhooks.length === 0 ? (
                <div className="text-center py-12 bg-white rounded-xl border border-gray-200 border-dashed">
                    <div className="mx-auto w-12 h-12 bg-gray-50 rounded-full flex items-center justify-center mb-3">
                        <Webhook className="w-6 h-6 text-gray-400" />
                    </div>
                    <h3 className="text-gray-900 font-medium mb-1">No webhooks configured</h3>
                    <p className="text-gray-500 text-sm mb-4">Add a Discord webhook to start receiving notifications.</p>
                    <button
                        type="button"
                        onClick={onAdd}
                        className="text-blue-600 font-medium text-sm hover:underline"
                    >
                        Add your first webhook
                    </button>
                </div>
            ) : (
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                    <table className="w-full text-left text-sm">
                        <thead className="bg-gray-50 border-b border-gray-100">
                            <tr>
                                <th className="px-6 py-4 font-semibold text-gray-900">Name</th>
                                <th className="px-6 py-4 font-semibold text-gray-900">Webhook URL</th>
                                <th className="px-6 py-4 font-semibold text-gray-900 text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {webhooks.map((webhook) => (
                                <tr key={webhook.id} className="hover:bg-gray-50 transition-colors group">
                                    <td className="px-6 py-4 font-medium text-gray-900">
                                        <div className="flex items-center gap-3">
                                            <div className="p-2 bg-indigo-50 text-indigo-600 rounded-lg">
                                                <MessageCircle className="w-4 h-4" />
                                            </div>
                                            {webhook.name}
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 text-gray-500 font-mono text-xs truncate max-w-[200px]">
                                        {webhook.url}
                                    </td>
                                    <td className="px-6 py-4 text-right">
                                        <div className="flex items-center justify-end gap-2 text-gray-400">
                                            <button
                                                type="button"
                                                onClick={() => onEdit(webhook)}
                                                className="p-2 hover:bg-white hover:text-blue-600 hover:shadow-sm rounded-lg transition-all border border-transparent hover:border-gray-200"
                                                title="Configure Settings"
                                                aria-label="Configure Settings"
                                            >
                                                <SettingsIcon className="w-4 h-4" />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => onDelete(webhook.id)}
                                                className="p-2 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
                                                title="Delete Webhook"
                                                aria-label="Delete Webhook"
                                            >
                                                <Trash2 className="w-4 h-4" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
